<script>
  import Vue from 'vue'
  import { castArray } from 'vtils'
  import { MasonryContainer } from './masonry_container'
  import { pxToRem } from '@/utils'

  export default Vue.extend({
    props: {
      colCount: {
        type: Number,
        required: true,
      },
      gap: {
        type: Number,
        default: 0,
      },
      rowGap: {
        type: Number,
        default: 0,
      },
      colGap: {
        type: Number,
        default: 0,
      },
    },

    computed: {
      _rowGap() {
        return `${pxToRem(this.rowGap || this.gap)}rem`
      },
      _colGap() {
        return `${pxToRem(this.colGap || this.gap)}rem`
      },
      _listStyle() {
        return {
          marginTop: `-${this._rowGap}`,
        }
      },
      _itemStyle() {
        return {
          paddingTop: `${this._rowGap}`,
        }
      },
    },

    render(h) {
      return h(
        MasonryContainer,
        {
          ref: 'masonry',
          props: {
            cols: this.colCount,
            gutter: this._colGap,
          },
          style: this._listStyle,
        },
        castArray(this.$slots.default || []).map(node =>
          h(
            'div',
            {
              key: node.key,
              style: this._itemStyle,
            },
            [node],
          ),
        ),
      )
    },
  })
</script>
